import React from 'react'
import styled, { css } from 'styled-components'
import { YouTubeVid } from '.'

export const youTubeThumbStyles = css``

const YouTubeThumbView = styled.div`
	${youTubeThumbStyles}
`

export type YouTubeThumbProps = {
	video: YouTubeVid
	className?: string
}
export const YouTubeThumb = ({ video, className }: YouTubeThumbProps) => {
	const { youTubeVidId, title } = video
	const thumbUrl = `https://img.youtube.com/vi/${youTubeVidId}/0.jpg`
	return (
		<YouTubeThumbView className={`yt-thumb${className ? ` ${className}` : ''}`}>
			<img src={thumbUrl} alt={title} />
		</YouTubeThumbView>
	)
}
